<template>
  <div class="h-full">
    <PublicPageTemplate>
      <template v-slot:content>
        <PublicPageHeader :title="$t('mfa.needToUseYourRecoveryCodeNoProblem')" :info="$t('mfa.enterYourRecoveryCodeBelow')" class="mb-base" />
        <div class="mb-lg">
          <TextInput
              id="recovery-code"
              class="px-base py-base text-4xl"
              :placeholder="$t('mfa.recoveryCode')"
              v-model="recoveryCode"
              data-ec="use_recovery_code"
              data-et="recovery_code_input"
              :has-error="errorMessage !== null"
          />
          <div class="w-full text-sm">
            <div
              v-if="errorMessage"
              data-test="error-message"
              class="p-base mt-sm bg-warning2 text-whiteOverride text-center rounded-lg">
              <ExclamationTriangleIcon class="mr-base" />
              <span data-test="error" >{{ errorMessage }}</span>
            </div>
          </div>
        </div>
        <PublicPageSubmitButton :disabled="disableConfirmButton" :text="$t('functional.confirm')" @click="authenticate" class="mb-base" />
        <div class="text-center text-sm mt-md">
          <RouterLink to="/two-factor-authentication" class="text-black font-normal hover:text-primary">
            {{ $t('mfa.backToAuthenticationViaApp') }}
          </RouterLink>
          <hr class="mt-base mb-base" />
          <p class="text-black font-normal mb-0">{{ $t('mfa.lostYourRecoveryCodeContactYourAdministrator') }}</p>
          <hr class="mt-base mb-base" />
          <a href="#" @click="logout" class="text-black font-normal hover:text-primary">{{ $t('functional.logOutVerb') }}</a>
        </div>
      </template>
    </PublicPageTemplate>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PublicPageHeader from '@/components/tailwind/publicPages/PublicPageHeader.vue';
import PublicPageSubmitButton from '@/components/tailwind/publicPages/PublicPageSubmitButton.vue';
import TextInput from '@/components/tailwind/forms/TextInput.vue';
import PublicPageTemplate from '@/components/tailwind/publicPages/PublicPageTemplate.vue';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'UseRecoveryCode',
  components: {
    PublicPageHeader,
    PublicPageSubmitButton,
    TextInput,
    PublicPageTemplate,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      recoveryCode: null,
      errorMessage: null,
      successDisplay: false,
    };
  },
  computed: {
    ...mapGetters({
      userMfa: 'userMfa/userMfa',
    }),
    disableConfirmButton() {
      return this.recoveryCode === null || this.recoveryCode === '';
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/LOGOUT',
      validatedRecoveryCode: 'userMfa/VALIDATE_RECOVERY_CODE',
      getUserMfa: 'userMfa/GET',
    }),
    authenticate() {
      this.validatedRecoveryCode({ code: this.recoveryCode }).then(async (response) => {
        // Fetch the user MFA record and store it in state
        await this.getUserMfa();
        this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('authentication.authenticationSuccessMessage'), icon: 'check', type: 'success' }));
        this.$router.push({ name: 'MFARecoveryCode', params: { recoveryCode: response.data.code, mfaSetup: false } });
      }).catch((error) => {
        this.errorMessage = error.response?.data?.message || this.$t('functional.error');
      });
    },
  },
};
</script>
